export const REQUEST_BATCH_SIZE = 1000;
